module.exports = __webpack_public_path__ + "img/W-33.961ab34f.jpg";